let formsReadyCount = 0;
const totalForms = $('.big-form-parent').length;
let combinedFormHeight = 0;
let dependentInputParentHeight = undefined;

const animateDependentInput = (direction, dependentParent, activeCount) => {
  setTimeout(() => {
    const dependentInputParent = dependentParent.find('.hs-form-field:has(input)');
    if (dependentInputParentHeight == undefined) {
      dependentInputParentHeight = pxToVw(dependentInputParent.outerHeight(true));
    }
    gsap.to(dependentParent, {
      height: direction ? `+=${dependentInputParentHeight}vw` : `-=${dependentInputParentHeight}vw`,
      duration: 0.6,
      ease: 'pageInEasing',
    });
    if (direction) {
      gsap.fromTo(
        dependentInputParent,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.6,
          ease: 'pageInEasing',
        }
      );
    }
  }, 100);
};

const resizeForm = () => {
  let topMargin = 0;

  if (isTablet()) {
    topMargin = pxToVw($('.form-container-overflow').outerHeight(true));
  }
};

const changeFormHeight = (height, duration) => {
  formElementsSelectors = [];
  const formElements = $('.form-changes-element');
  gsap.to(formElements, {
    height: `${height}vw`,
    duration: 0.6,
    ease: 'pageInEasing',
  });
};

const labelBGAnimation = (sectionParent, progress = 0) => {
  const labels = sectionParent.find('.label');
  const labelsParent = labels.parent();
  const firstLabelWidth = pxToVw(labels.eq(0).outerWidth());
  const labelsGap = pxToVw(Number(labelsParent.css('gap').replace('px', '')));
  const labelsBG = sectionParent.find('.labels-bg');
  

  const labelTL = gsap.timeline(/*{ paused: true }*/);

  labelTL.add(gsap.fromTo(labelsBG, {
    width: `${firstLabelWidth}vw`,
    x: 0,
  }, {
    width: '100%',
    x: 0,
    duration: 0.85,
    ease: 'pageInEasing',
  }), 0);
  labelTL.add(gsap.to(labelsBG, {
    width: `${pxToVw(labels.eq(1).outerWidth())}vw`,
    x: `${pxToVw(labels.eq(0).outerWidth()) + labelsGap}vw`,
    duration: 0.85,
    ease: 'pageInEasing',
  }), 0.85);

  return labelTL;
};

const animateFormSwitch = (sectionParent) => {
  const combinedForm = sectionParent.find('.combined-form-parent');
  const formSwitcher = sectionParent.find('.switch input');
  const formPlacer = sectionParent.find('.big-form-placer');
  const labels = sectionParent.find('.label');
  const formAnimation = [];
  let isReversed = false;
  formPlacer.each(function (index) {
    const formBtn = $(this).find('.button-parent');
    index == 0 ? $(this).toggleClass('active') : false;
    formAnimation.push(animateFormIn($(this)));
  });

  let labelBGTL = labelBGAnimation(sectionParent);

  const formTL = gsap.timeline({
    paused: true,
    onUpdate: () => {
      const progress = formTL.progress();
      if (Math.abs(progress - 0.5) < 0.1) {
        if (formTL.reversed() == isReversed) {
          isReversed = !isReversed;
          formTL.reversed() ? animateFormLines(sectionParent, 0) : animateFormLines(sectionParent, 1);
        }
      }
    },
  });
  formAnimation[0].progress(1);
  formTL.add(labelBGTL, 0);
  formTL.add(formAnimation[0].reverse(), 0);
  formTL.add(formAnimation[1].play(), 0.85);

  labels.on('click', function () {
    const currentLabel = $(this).is(labels.eq(0));
    !currentLabel ? formTL.play() : formTL.reverse();
  });

  $(window).on('resize', () => {
    const progress = labelBGTL.progress();
    console.log(progress)
    const isRev = labelBGTL.reversed();
    formTL.remove(labelBGTL);
    labelBGTL = labelBGAnimation(sectionParent, progress);
    formTL.add(labelBGTL, 0);
    labelBGTL.progress(progress).reversed(isRev);
  });
};

const animateFormLines = (sectionParent, lineIndex) => {
  const formPlacer = sectionParent.find('.big-form-placer').eq(lineIndex);
  const formLines = formPlacer.find('.input-line');
  gsap.fromTo(
    formLines,
    {
      width: '0%',
    },
    {
      width: '100%',
      duration: 0.633,
      stagger: {
        each: 0.1,
      },
      delay: 0.2,
    }
  );
};

const animateFormIn = (formPlacer, duration = {formPlacer: 0.567, formOverflows: 0.85}) => {
  const formImageOverflow = formPlacer.find('.big-form-image-overflow');
  const formOverflow = formPlacer.find('.form-container-overflow');
  const formOverflows = formPlacer.find('.form-overflow');
  const formContainer = formPlacer.find('.form-container');
  const formWidth = pxToVw(formContainer.outerWidth(true));
  const formImage = formPlacer.find('.big-form-image');

  const formInTL = gsap.timeline({ paused: true });
  formInTL.add(
    gsap.fromTo(
      formPlacer,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: duration.formPlacer,
        ease: 'pageInEasing',
        onComplete: () => {
          formPlacer.css('pointer-events', 'all');
        },
        onReverseComplete: () => {
          formPlacer.css('pointer-events', 'none');
        }
      }
    ),
    0.0
  );
  formInTL.add(
    gsap.fromTo(
      formOverflows,
      {
        width: 0,
      },
      {
        width: `100%`,
        duration: duration.formOverflows,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  /*
  formInTL.add(
    gsap.fromTo(
      formImage,
      {
        x: '20%',
      },
      {
        x: '0',
        duration: 0.75,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  */
  return formInTL;
};

const animateFormInSlow = (formPlacer) => {
  const formImageOverflow = formPlacer.find('.big-form-image-overflow');
  const formOverflow = formPlacer.find('.form-container-overflow');
  const formOverflows = formPlacer.find('.form-overflow');
  const formContainer = formPlacer.find('.form-container');
  const formWidth = pxToVw(formContainer.outerWidth(true));
  const formImage = formPlacer.find('.big-form-image');
  const formInEasing = CustomEase.create('formInEasing', '0.2, 1, 0.2, 1');

  const formInTL = gsap.timeline({ paused: true });
  formInTL.add(
    gsap.fromTo(
      formPlacer,
      {
        opacity: 1,
      },
      {
        opacity: 1,
        duration: 2,
        ease: 'formInEasing',
      }
    ),
    0.0
  );
  formInTL.add(
    gsap.fromTo(
      formOverflows,
      {
        width: 0,
      },
      {
        width: `100%`,
        duration: 2,
        ease: 'formInEasing',
      }
    ),
    0
  );
  /*
  formInTL.add(
    gsap.fromTo(
      formImage,
      {
        x: '20%',
      },
      {
        x: '0',
        duration: 0.75,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  */
  return formInTL;
};
